import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Secchi } from 'src/app/domain/Lac - EAU/secchi';

@Component({
    selector: 'app-secchi-box',
    templateUrl: './secchi-box.component.html',
    styleUrls: ['./secchi-box.component.scss']
})
export class SecchiBoxComponent implements OnInit {
    public PMAX = 150; // cm
    public DMAX = 20; // m
    public Model: Secchi = new Secchi();
    // ValidDistanceMax = new FormControl(0, [Validators.max(this.DMAX)]);
    // ValidProfMax = new FormControl(0, [Validators.max(this.PMAX)]);

    constructor(
        private dialogRef: MatDialogRef<SecchiBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {

        this.Model = data;
    }

    ngOnInit(): void {
        // this.ValidDistanceMax.markAsTouched();
        // this.ValidProfMax.markAsTouched();
    }

    CanAddNewMeasure() {
        return this.Model.Disparition && this.Model.Reapparition;
        // && this.ValidDistanceMax.valid && this.ValidProfMax.valid;
    }

    checkForOnlyNumericValueWithtoutComma(event: KeyboardEvent) {

        var regex = /^\d+$/;
        var matches = regex.exec(event.key);
        if (!matches) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.Model);
    }
}
